<template>  
  <v-container grid-list-lg fluid class="ma-0 pa-0">
    <v-layout row>
      <v-flex xs12 v-if="skeletonLoading">
        <v-skeleton-loader          
          type="card, article, actions"
          style="width:100%"
        ></v-skeleton-loader>
      </v-flex>
      <v-flex xs12 md12 v-else>
        <form @submit.prevent="onsubmit">          
          <v-card>                    
            <v-toolbar flat dense color="cyan">
              <v-spacer />
              <v-btn type="submit" :color="isUpdate?'blue':'green'" :loading="loading" dark>{{isUpdate?'update':'create'}}</v-btn>
              <v-menu
                bottom
                left
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item @click="deleteData">
                    <v-list-item-title>delete</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-toolbar>
            <v-card-text>           
              <v-layout row>
                <v-flex xs12 md4>
                  <v-text-field outlined dense
                    label="Name"
                    v-model="fm.name"
                    append-icon="grade"
                    type="text"
                    :error="!!error.name.length"
                    :error-messages="error.name"
                  ></v-text-field>  
                  <v-text-field outlined dense
                    label="Description"
                    v-model="fm.description"
                    append-icon="description"
                    type="text"
                    :error="!!error.description.length"
                    :error-messages="error.description"
                  ></v-text-field>           
                </v-flex>
                <v-flex xs12 md8>
                  <v-autocomplete outlined dense
                    v-model="fm.node_ids"
                    multiple
                    label="Area"
                    :items="nodes"
                    item-text="name"
                    item-value="id"
                    :loading="nodeLoading"
                    @keyup="search"
                    :error="!!error.node_id.length"
                    :error-messages="error.node_id"
                  >                    
                    <template v-slot:item="data">                
                      <template>
                        <v-list-item-content>
                          <v-list-item-title v-html="data.item.name"></v-list-item-title>
                          <v-list-item-subtitle>{{ data.item.parent_name }}</v-list-item-subtitle>
                          <v-list-item-subtitle><strong>TINGKAT : {{ data.item.levelText }}</strong></v-list-item-subtitle>
                        </v-list-item-content>
                      </template>
                    </template>
                  </v-autocomplete>  
                  <v-layout row style="margin-top:-8px">
                    <v-flex xs6>
                      <v-text-field
                        outlined dense
                        label="Distribusi"
                        v-model="fm.lembar"
                        suffix="lbr"
                        type="number"
                        :error="!!error.lembar.length"
                        :error-messages="error.lembar"
                      >
                      </v-text-field>
                    </v-flex>
                    <v-flex xs6>
                      <v-text-field
                        outlined dense
                        label="Customer Dist"
                        v-model="fm.lembar_custom"
                        suffix="lbr"
                        type="number"
                        :error="!!error.lembar_custom.length"
                        :error-messages="error.lembar_custom"
                      >
                      </v-text-field>
                    </v-flex>
                  </v-layout>                                                                                    
                </v-flex>
                <v-flex xs12 md4>
                  <v-menu
                    v-model="colorpicker"              
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y              
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field outlined dense                  
                        v-model="fm.color"
                        label="Color"
                        append-icon="invert_colors"                  
                        v-on="on"
                        style="width:200px;"
                        :background-color="fm.color"
                        hide-details
                      ></v-text-field>
                    </template>
                    <v-color-picker v-model="fm.color"></v-color-picker>                
                  </v-menu>                  
                  <v-switch v-model="fm.status" :label="fm.status === 1?'Status:Active':'Status:Inactive'" :true-value="1" :false-value="0"></v-switch>                            
                </v-flex>
                <v-flex xs12 md8>
                  <v-textarea outlined dense hide-details label="other optional" v-model="fm.option"></v-textarea>
                </v-flex>
              </v-layout>
            </v-card-text>  
            <v-toolbar color="cyan lighten-4" flat dense>
              <h3>Quetionnaire</h3><v-spacer/>
              <v-autocomplete 
                hide-details 
                v-model="template_id" 
                autocomplete="off" 
                :items="templates"
                item-text="name"
                item-value="id"
                :loading="templateLoading"
                @keyup="searchQuetionnaire" 
                outlined dense 
                class="mr-2" style="max-width:150px" 
                label="Load Template"
              >
              </v-autocomplete>
              <v-btn small fab dark color="green" @click="addQuetion"><v-icon>add</v-icon></v-btn>             
            </v-toolbar>
            <v-card-text>
              <template v-for="(quetion, i) in fm.quetionnaires">
                <v-layout row :key="i+'-'+quetion.id">                
                  <v-flex xs3 md1>
                    <v-text-field outlined dense
                      label="No"
                      v-model="quetion.no"
                      type="number"           
                      hide-details        
                      autocomplete="off"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs8 md10>
                    <v-text-field outlined dense
                      label="Question"
                      v-model="quetion.question"
                      type="text"          
                      hide-details   
                      autocomplete="off"                      
                    ></v-text-field>
                  </v-flex>      
                  <v-flex xs1 md1>
                    <v-btn style="float:right" @click="delQuetion(i)" small icon dark color="red"><v-icon>delete</v-icon></v-btn>             
                  </v-flex>                      
                  <v-flex xs12 md5>
                    <v-radio-group v-model="quetion.type" label="type :" class="mt-0" row hide-details>
                      <v-radio :label="`Optional`"   :value="1"></v-radio>
                      <v-radio :label="`Additional`" :value="2"></v-radio>                    
                      <v-radio :label="`Isian`"      :value="3"></v-radio>
                    </v-radio-group>
                  </v-flex>    
                  <v-flex xs4 md1>
                    <v-select   
                      label="kompetisi"
                      outlined dense hide-details                   
                      :items="kompetisis"                       
                      v-model="quetion.kompetisi_id"
                      item-text="name"
                      item-value="id"
                     >
                    </v-select>
                  </v-flex>    
                  <v-flex xs4 md1>
                    <v-select   
                      label="import data"
                      outlined dense hide-details                   
                      :items="importTypes"                       
                      @change="importdata($event, quetion)"
                     >
                    </v-select>
                  </v-flex>
                  <v-flex xs4 md2>
                    <v-checkbox v-model="quetion.custom" class="mt-0" :true-value="1" :false-value="0" hide-details label="forcustomer" />
                  </v-flex>    
                  <v-flex xs12 md7 style="position:relative">
                    <v-btn icon small color="blue" style="position:absolute; right:25px" @click="addOption(quetion)"><v-icon>add</v-icon></v-btn>
                    <v-data-table dense 
                      :headers="headers"
                      :items="quetion.option"              
                      :loading="loading"
                      loading-text="Loading... Please wait"
                      :items-per-page="-1"
                      hide-default-footer  
                      class="elevation-1"                        
                      :mobile-breakpoint="0"                
                    >               
                      <template v-slot:item.no="{ item }">{{ item.id = item.id ? item.id : (quetion.option.findIndex(x=>x==item)+1) }}</template>
                      <template v-slot:item.key="{ item }">                        
                        <v-text-field :set="item.key=item.key===null?numberToLetters(item.id-1):item.key" dense hide-details v-model="item.key" placeholder="type here"></v-text-field>
                      </template>
                      <template v-slot:item.value="{ item }">
                        <v-text-field dense hide-details v-model="item.value"></v-text-field>
                      </template>
                      <template v-slot:item.action="{ item }">
                        <v-btn icon small color="red" @click="delOption(quetion, item)"><v-icon>close</v-icon></v-btn>
                      </template>              
                    </v-data-table>                  
                  </v-flex>      
                </v-layout>                                                 
              </template>  
            </v-card-text>
            <v-card-actions class="pa-4">
              <v-spacer />
              <v-btn type="submit" :color="isUpdate?'blue':'green'" :loading="loading" dark>{{isUpdate?'update':'create'}}</v-btn>
            </v-card-actions>
          </v-card>
        </form>   
      </v-flex>            
    </v-layout>
  </v-container>    
</template>

<script>
import { debounce } from 'lodash'
import Model from '@/app/models/master/Quetionnaire'
const  model = new Model();

export default {
  data : () => ({  
    fm:{ name: null, node_id:null, node_ids:[], description:null, color:'#fff', lembar:null, lembar_custom:null, status:1, quetionnaires:[], option:null},
    error:{ name : [], node_id:[], description:[], color:[], lembar:[], lembar_custom:[], status:[], quetionnaires:[], option:[]},
    headers: [
      {text:'No', value:'no', width:70, sortable:false},
      {text:'Key', value:'key', width:180, sortable:false},
      {text:'Value', value:'value',  width:300, sortable:false},
      {text:'', value:'action', width:50, sortable:false},
    ],
    items:[{
      id:1, key:'A', value:'helo'
    }],
    loading: false,
    isUpdate: false,    
    mode: 0,        
    nodes: [], nodeLoading:false,
    colorpicker:false,
    importTypes:['calon','partai'],
    template_id:null,
    templates:[], templateLoading: false,
    skeletonLoading : false,
  }),
  computed:{
    
  },
  watch:{
    'fm.node_id'(newId){
      if(newId){
        let nd = this.nodes.find(x=>x.id==newId);
        if(!nd){
          model.node({id:newId}).then(data=>{
            this.nodes.push(data);
            this.fm.node_id = null;
            this.fm.node_id = data ? data.id :null;              
          })    
        }
      }      
    },
    'fm.node_ids'(newIds){
      newIds.forEach(async (id)=>{
        let data = await model.node({id:id})
        this.nodes.push(data)
      })      
    },
    template_id(newId){
      if(newId){
        let jil = this.templates.find(x=>x.id==newId);
        if(jil){          
          //this.fm.quetionnaires = []
          jil.quetionnaires.forEach(item=>{
            this.fm.quetionnaires.push({
              no:item.no,
              type:item.type,
              name:item.name,
              option:item.option,
              question:item.question,
              custom:item.custom
            });
          })           
          console.log(this.fm.quetionnaires)
        }
      }
    }
  }, 
  mounted(){
    if(this.$route.query.id){
      this.isUpdate = true; this.skeletonLoading = true;
      model.view({id:this.$route.query.id, expand:'quetionnaires'}).then(data=>{                
        this.skeletonLoading = false;
        Object.assign(this.fm, data);
        if(!this.fm.node_ids){
          this.fm.node_ids = [this.fm.node_id.toString()] 
        }
        this.fm.area_id = String(this.fm.area_id);
        setTimeout(()=>{
          this.fm.option = data.option;
          if(Array.isArray(this.fm.option)){
            this.fm.option.forEach((item, i)=>{                          
              if(item.option &&  typeof(item.option) == 'object'){                            
                this.fm.option[i].option = JSON.stringify(item.option);
              }
            });
          } else if(this.fm.option &&  typeof(this.fm.option) == 'object'){
            this.fm.option = JSON.stringify(this.fm.option);
          }
        }, 100);
      })
    }
    
    model.kompetisis().then(data=>{
      this.kompetisis = data;
    });
  },
  methods: {
    search: debounce(function (e) {      
      this.readNodes(e.target.value)
    }, 400),

    searchQuetionnaire: debounce(function (e) {      
      this.templateLoading = true;
      model.all({q:e.target.value,expand:'quetionnaires'}).then(res=>{
        this.templates = res.data;
        this.templateLoading = false;
      });
    }, 400),

    readNodes(term){
      this.nodeLoading = true;
      model.nodes({q:term,level:this.fm.tingkat}).then(res=>{
        this.nodes = [...this.nodes, ...res.data];
        this.nodeLoading = false;
      })
    },

    importdata(e, quetion){
      model.importdata({type:e, kompetisi_id:quetion.kompetisi_id}).then(data=>{        
        if(Array.isArray(data)){
          quetion.option = [];
          data.forEach(item=>{
            quetion.option.push({id:item.id,key:item.no,value:item.name});
          })
        }        
      })
    },
    
    addQuetion(){      
      let no = this.fm.quetionnaires.length + 1;
      this.fm.quetionnaires.push({no:no, question:null, type:1, option:[]})
    },

    delQuetion(i){
      this.fm.quetionnaires.splice(i, 1);
      this.fm.quetionnaires = JSON.parse(JSON.stringify(this.fm.quetionnaires))      
    },

    addOption(quetion){
      quetion.option.push({id:null, key:null, value: null});
    },

    delOption(quetion, item){
      quetion.option.splice(quetion.option.findIndex(x=>x===item), 1);
    },

    onsubmit(){
      this.loading = true;  this.clearErrors();
      this.fm.option = this.fm.option && !Array.isArray(this.fm.option) ? JSON.parse(this.fm.option) : null;
      if(this.isUpdate){        
        model.update(this.fm, {id:this.fm.id}).then(res=>{this.responseSubmit(res)})
      } else {        
        model.create(this.fm).then(res=>{this.responseSubmit(res)})
      }
    },

    responseSubmit(res){
      this.loading = false;
      if(res.status === 200){
        window.getApp.$emit('showSnackbar', {text :'Data has been saved successfully', color: 'green', show:true});            
        this.$router.replace({name:'master/quetionnaire'})                
      } else {
        this.validate(res.data);
      }
    },

    validate(data){      
      for(var i in data){        
        if(Array.isArray(this.error[data[i]['field']])){          
          this.error[data[i]['field']].push(data[i]['message']);
        }        
      }
    },

    clearErrors(){
      this.error.name    = [];
      this.error.type    = [];
      this.error.address = [];
      this.error.email   = [];
      this.error.node_id = [];      
    },

    deleteData(){
      this.$swal({title: 'Are you sure?', text: "You won't be able to revert this!",
        showCancelButton: true, confirmButtonColor: '#3085d6', cancelButtonColor: '#d33', confirmButtonText: 'Yes, delete it!'
      }).then((result) => {                 
        if (result.value) {                 
          this.loading = true;             
          model.deleteOnline({id:this.fm.id}).then(res=>{ 
            if(res.status == 200){
              window.getApp.$emit('showSnackbar', {text :'Data has been deleted', color: 'green', show:true}); 
              this.$router.replace({name:'master/quetionnaire'})              
            }                       
            this.loading = false;
          })
        }
      });
    },

    numberToLetters(num) {
      let letters = ''
      while (num >= 0) {
          letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'[num % 26] + letters
          num = Math.floor(num / 26) - 1
      }
      return letters
    }
  },
}
</script>

<style>
.ramping td, .ramping th {
    padding: 0 5px;
}
.v-data-table-header-mobile__wrapper .v-select {
    max-width:200px !important;
}
</style>